// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useLabels, useFormat } from 'utilities/hooks';

// Components
import Card from 'components/_cardContentElements';

const ResultsIntellectualProperty = ({
    item,
    theme = 'teal',
    wrap = false,
}) => {
    // ///////////////////
    // DATA
    // ///////////////////

    const { Description__c } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <Card.CardContentWrapper
            {...{
                wrap,
            }}>
            {/* Description */}
            {Description__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                    }}>
                    <p>{Description__c}</p>
                </Card.CardContentSection>
            )}

            {/* Details */}
            <ResultsIntellectualPropertyDetails {...{ item, theme }} />
        </Card.CardContentWrapper>
    );
};

const ResultsIntellectualPropertyDetails = ({ item, theme }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();
    const format = useFormat();

    // ///////////////////
    // DATA
    // ///////////////////

    const { Intellectual_Property_Id__c, Year__c } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            {/* Various Info */}
            {[Intellectual_Property_Id__c, Year__c].some(x => x) && (
                <Card.CardContentPairBox>
                    {Year__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Year__c___Intellectual_Property'
                                ),
                                value: format.year(Year__c),
                            }}
                        />
                    )}

                    {Intellectual_Property_Id__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Intellectual_Property_Id__c'
                                ),
                                value: Intellectual_Property_Id__c,
                            }}
                        />
                    )}
                </Card.CardContentPairBox>
            )}
        </>
    );
};

ResultsIntellectualProperty.propTypes = {
    item: t.object,
};

ResultsIntellectualProperty.defaultProps = {};

export { ResultsIntellectualPropertyDetails };
export default ResultsIntellectualProperty;
